module.exports = __webpack_public_path__ + "img/TechGatherFarm1_ua.6f55fea1.webp";